__turbopack_context__.v({
  "errorWrapper": "audio-guide-search-module-scss-module__7heBtW__errorWrapper",
  "inputWrapper": "audio-guide-search-module-scss-module__7heBtW__inputWrapper",
  "searchIcon": "audio-guide-search-module-scss-module__7heBtW__searchIcon",
  "searchSection": "audio-guide-search-module-scss-module__7heBtW__searchSection",
});
